import React, { useCallback, useRef } from 'react';
import { View, } from 'react-native';
import { Text } from '@rneui/themed';
import BottomSheet, { BottomSheetScrollView } from '@gorhom/bottom-sheet';
import { Portal } from '@gorhom/portal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '../../../hooks';
import { Description } from '../../../components/shared';
import { BottomSheetBackdrop } from '../../..';
export const UnmemoizedInfo = ({ title = '', description = '', onClose, }) => {
    const { top, bottom } = useSafeAreaInsets();
    const { colors } = useTheme();
    const bottomSheetRef = useRef(null);
    const handleSheetChanges = useCallback((index) => {
        if (index < 0) {
            onClose();
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Portal, { hostName: "modal" },
            React.createElement(BottomSheet, { ref: bottomSheetRef, backdropComponent: BottomSheetBackdrop, index: 0, enablePanDownToClose: true, enableDynamicSizing: false, snapPoints: ['75%', '100%'], topInset: top, backgroundStyle: { backgroundColor: colors.backgroundPrimary }, handleIndicatorStyle: { backgroundColor: colors.textPrimary }, containerStyle: { zIndex: 3000 }, onChange: handleSheetChanges },
                React.createElement(BottomSheetScrollView, null,
                    React.createElement(View, { style: { paddingHorizontal: 15, paddingBottom: bottom } },
                        React.createElement(Text, { h3: true, bold: true, style: { textAlign: 'left' } }, title),
                        React.createElement(Description, { text: description })))))));
};
export const Info = React.memo(UnmemoizedInfo, (prev, next) => {
    return prev.title === next.title &&
        prev.description === next.description;
});
//# sourceMappingURL=Info.js.map